/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateRepeatableTaskForm } from '../models/CreateRepeatableTaskForm';
import type { EditRepeatableTaskForm } from '../models/EditRepeatableTaskForm';
import type { RepeatableTask } from '../models/RepeatableTask';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RepeatableTasksService {
    /**
     * Find a repeatable task by id
     * @returns RepeatableTask Repeatable task
     * @throws ApiError
     */
    public static findRepeatableTask({
        id,
    }: {
        /**
         * Id of repeatable task.
         */
        id: number,
    }): CancelablePromise<RepeatableTask> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/projects/task/repeatable/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `The user's team has no access to this feature or the user has no access to the repeatable task.`,
            },
        });
    }
    /**
     * Edit a repeatable task
     * @returns RepeatableTask Edited repeatable task
     * @throws ApiError
     */
    public static editRepeatableTask({
        id,
        requestBody,
    }: {
        /**
         * Id of repeatable task.
         */
        id: number,
        /**
         *   The fields to be edited.
         * If a field is omitted, it will not be edited. If a field is set to null,
         * however, it will be - if possible - set to null.
         *
         * If the `period` or the `rate` is edited, the other must be adjusted,
         * so that both of the are sensibly combined, as described.
         *
         */
        requestBody: EditRepeatableTaskForm,
    }): CancelablePromise<RepeatableTask> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/projects/task/repeatable/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `The user's team has no access to this feature or the user has no access to the repeatable task.`,
            },
        });
    }
    /**
     * Delete a repeatable task
     * @returns any Repeatable task has been deleted.
     * @throws ApiError
     */
    public static deleteRepeatableTask({
        id,
    }: {
        /**
         * Id of repeatable task.
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/projects/task/repeatable/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `The user's team has no access to this feature or the user has no access to the repeatable task.`,
            },
        });
    }
    /**
     * Create a new repeatable task
     * @returns RepeatableTask Created repeatable task
     * @throws ApiError
     */
    public static createRepeatableTask({
        requestBody,
    }: {
        /**
         * The new task to be created.
         * Following fields are required:
         * - `name`
         * - `period`
         * - `rate`
         * - `hourlyDueDuration` (>= 0)
         * - `assignees` (may be empty)
         *
         * If both provided, the `start` timestamp may not be after the `end` timestamp.
         *
         */
        requestBody: CreateRepeatableTaskForm,
    }): CancelablePromise<RepeatableTask> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/projects/task/repeatable',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request body is invalid:
                Required fields could be missing or be invalid.
                Furthermore, the \`period\` and \`rate\` combination could be invalid.
                `,
                403: `The user's team has no access to this feature or the user has no access to the specified project.`,
            },
        });
    }
    /**
     * Lists (filtered) repeatable tasks
     * @returns RepeatableTask (Filtered) repeatable tasks
     * @throws ApiError
     */
    public static listRepeatableTasks({
        assigned,
    }: {
        /**
         * Filter if the executing user is assigned to the repeatable tasks.
         */
        assigned?: boolean,
    }): CancelablePromise<Array<RepeatableTask>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/projects/tasks/repeatable',
            query: {
                'assigned': assigned,
            },
            errors: {
                403: `The user's team has no access to this feature or the user has no access to the specified project.`,
            },
        });
    }
}
